// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"601":"567d5be95c9ad14a","636":"4a2a10d038eca3a6","1413":"567d5be95c9ad14a","8312":"567d5be95c9ad14a"}[chunkId] + ".css";
};